<form [formGroup]="resetForm" (ngSubmit)="onResetPassword()">
<h2 mat-dialog-title>Reestablecer contrase&ntilde;a</h2>
<mat-dialog-content>
    <p>Ingrese el nombre de usuario y el correo asociado a su cuenta, y le envieremos un correo con instrucciones para resetear su contrase&ntilde;a</p>
    <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nombre de usuario</mat-label>
        <input matInput formControlName="usuario" [readonly]="loading"/>
    </mat-form-field>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Correo electr&oacute;nico</mat-label>
      <input matInput formControlName="correo" [readonly]="loading"/>
  </mat-form-field>
</mat-dialog-content>
@if(loading){
<mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
}
<mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="onNoClick()">Cerrar</button>
    <button mat-flat-button [disabled]="!resetForm.valid || loading" >Continuar</button>
</mat-dialog-actions>
</form>

